
/* Sve — client-side language switch. French is rendered server-side by Liquid;
   every other language is applied by swapping text nodes flagged data-i18n. */
(function () {
  var KEY = "seve.lang";
  var LANGS = ["fr", "en", "it", "es", "pt"];
  var cache = {};
  var current = "fr";

  function get(obj, path) {
    var parts = path.split("."), cur = obj;
    for (var i = 0; i < parts.length; i++) {
      if (cur == null) return undefined;
      cur = cur[parts[i]];
    }
    return cur;
  }

  function apply(pack) {
    var nodes = document.querySelectorAll("[data-i18n]");
    for (var i = 0; i < nodes.length; i++) {
      var v = get(pack, nodes[i].getAttribute("data-i18n"));
      if (typeof v === "string") nodes[i].textContent = v;
    }
    var attrs = document.querySelectorAll("[data-i18n-attr]");
    for (var j = 0; j < attrs.length; j++) {
      var spec = attrs[j].getAttribute("data-i18n-attr").split(";");
      for (var k = 0; k < spec.length; k++) {
        var c = spec[k].indexOf(":");
        if (c < 0) continue;
        var val = get(pack, spec[k].slice(c + 1));
        if (typeof val === "string") attrs[j].setAttribute(spec[k].slice(0, c), val);
      }
    }
    document.documentElement.lang = current;
    if (window.SEVE_RENDER_SCRUB) window.SEVE_RENDER_SCRUB(pack);
  }

  function load(lang) {
    if (cache[lang]) return Promise.resolve(cache[lang]);
    return fetch(window.SEVE_PACKS[lang], { credentials: "omit" })
      .then(function (r) { return r.json(); })
      .then(function (p) { cache[lang] = p; return p; });
  }

  function setLang(lang) {
    if (LANGS.indexOf(lang) < 0) lang = "fr";
    current = lang;
    try { window.localStorage.setItem(KEY, lang); } catch (e) {}
    var sw = document.querySelector(".ln-lang");
    if (sw) {
      sw.setAttribute("data-open", "false");
      var short = sw.querySelector(".cta-lang .ln-lang-short");
      if (short) short.textContent = lang.toUpperCase();
      var flags = sw.querySelectorAll(".cta-lang .ln-flag");
      for (var i = 0; i < flags.length; i++) {
        flags[i].style.display = flags[i].getAttribute("data-flag") === lang ? "inline-block" : "none";
      }
      var opts = sw.querySelectorAll(".ln-lang-menu button");
      for (var j = 0; j < opts.length; j++) {
        opts[j].setAttribute("aria-selected", opts[j].getAttribute("data-lang") === lang ? "true" : "false");
      }
    }
    load(lang).then(apply).catch(function () {});
  }

  function detect() {
    try {
      var saved = window.localStorage.getItem(KEY);
      if (saved && LANGS.indexOf(saved) >= 0) return saved;
    } catch (e) {}
    // No browser sniffing: French is the default for everyone, including
    // crawlers. Another language only shows once the visitor picks one.
    return "fr";
  }

  function boot() {
    var sw = document.querySelector(".ln-lang");
    if (sw) {
      var toggle = sw.querySelector(".cta-lang");
      toggle.addEventListener("click", function () {
        sw.setAttribute("data-open", sw.getAttribute("data-open") === "true" ? "false" : "true");
      });
      var opts = sw.querySelectorAll(".ln-lang-menu button");
      for (var i = 0; i < opts.length; i++) {
        (function (b) {
          b.addEventListener("click", function () { setLang(b.getAttribute("data-lang")); });
        })(opts[i]);
      }
      document.addEventListener("click", function (e) {
        if (!sw.contains(e.target)) sw.setAttribute("data-open", "false");
      });
    }
    var initial = detect();
    if (initial !== "fr") setLang(initial);
    else if (window.SEVE_RENDER_SCRUB) {
      load("fr").then(window.SEVE_RENDER_SCRUB).catch(function () {});
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  window.SEVE_SET_LANG = setLang;
})();
